import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';
import { environment } from '../../environments/environment';

@Injectable()
export  class ConfigProvider {
  private header=APIService.getHeader();
  item;

  constructor(public http: HttpClient) {
  }
/**
 * Leitura da configuração
 */
  getConfig(){
    return Promise.resolve(environment);

  }
  getBanners(){
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {
    let url = APIService.API_URL + 'bannerlista';

    // let url = 'assets/banners/banners.json';
    ////console.log(requestData);
    this.http.get(url,{headers:me.header})
      .subscribe((result: any) => {
        var jsonData=result;
        if (jsonData.length!=0)
        {
          me.item=jsonData;
          resolve(me.item);
        }
        else{
          resolve(null);
        }
        
        
      },
      (error) => {
        var errochamada={
          'status_ret':'NOK',
          'erro':error.message
        }
        me.item=errochamada;
        reject(me.item);
      });
    });

  }
}
